import type { HudStore } from './store';

export function TitleScreen({ store, onStart }: { store: HudStore; onStart: () => void }) {
  const src = store.source.value;
  const snap = store.snapshot.value;
  const progress = store.loadProgress.value;
  let status: string;
  if (src.kind === 'replay') status = 'Live derby unavailable · showing a recorded race';
  else if (!snap) status = 'Connecting to the derby…';
  else if (snap.phase === 'finished') status = 'Between races';
  else status = 'Live race in progress';
  return (
    <section class="title-screen" aria-labelledby="title-wordmark">
      <div class="starburst" aria-hidden="true" />
      <h1 id="title-wordmark" class="wordmark">Cat Derby</h1>
      <p class="tagline">Six cats. One track. Catnip at your own risk.</p>
      {progress !== null && progress < 1 && (
        <div class="load" role="progressbar" aria-label="Loading the stadium" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress * 100)}>
          <span style={{ width: `${progress * 100}%` }} />
        </div>
      )}
      <p class={`signal-status tone-${src.kind}`} role="status">{status}</p>
      <button type="button" class="start" autofocus disabled={progress !== null && progress < 1} onClick={onStart}>
        {progress !== null && progress < 1 ? 'Loading…' : 'Start'}
      </button>
      <p class="hint">Sound starts after you press Start<span class="keys-hint"> · keys 1–6 follow a cat</span><span class="touch-hint"> · tap a cat in the standings to follow it</span></p>
      <p class="credits">
        Live race data from <a href="https://retro.kissaderby.fi/" target="_blank" rel="noopener">retro.kissaderby.fi</a> ·
        Cat model "Cat named Maggie" by chambersu1996, <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener">CC BY 4.0</a>, modified ·
        Textures from Poly Haven (CC0)
      </p>
    </section>
  );
}
